/* eslint-disable */
import 'moment-timezone';
import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { browserHistory } from 'react-router';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import language from '../../assets/languages/language';
import {
  // ANALYSTPREP_LOGO,
  // examNameAccordingToDB,
  // examNames,
  // examObject,
  // ADMIN_PROFILE_BASE_URL,
  // ROLES,
  // routeExamName,
  localStorageKeys,
} from '../../common/constant';
import { _getProfile } from '../../common/function';
import FD from '../../views/RestAPI/fetchData';
import App_data from '../../views/config/App_data';
import ExamDropdownMenu from './ExamDropdownMenu';
import HeaderCart from './HeaderCart';
import MobileSidebarToggle from './MobileSidebarToggle';
import UserAvatar from "../Partial/UserAvatar";
import UserStore from "../../store/userStore";
import {autorun} from "mobx";
import userStore from "../../store/userStore";
import {AppLogo} from "./AppLogo";
import {disconnectSocket} from "../../services/WebSocketService";
import { isAiTutorAvailable } from '../../common/aiTutorContext';

function normalizeAvatar(next, prev) {
  try {
    if (typeof next === 'string') {
      const v = next.trim().replace(/^["']|["']$/g, '');
      if (/^https?:\/\//i.test(v)) return v;
    }
    if (next && typeof next === 'object') {
      if (next.url) return String(next.url).trim();
      if (next.href) return String(next.href).trim();
      if (next.toString && next.toString !== Object.prototype.toString) {
        return String(next.toString()).trim();
      }
    }
  } catch (_) {}
  return prev || '';
}


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domain_name: window.location.hostname,
      avatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
      token: '',
      idname: '',
      AccountdropdownOpen: false,
      LanguagedropdownOpen: false,
      text_head: 'CFA Exams',
      language_selected: '',
      userName: '',
      exam_package: '',
      exam_selected: '',
      exam: '',
      subscription_details: '',
      user_id: '',
      showCustomerly: false,
      pageName: '',
      Expired: false,
      userRole: '',
      redirectParamURL: '',
      organizationLogo: '',
      loggedIn: false,
      cart_count: '',
    };

    this.goToProfile = this.goToProfile.bind(this);
    this.toggleAccountMenu = this.toggleAccountMenu.bind(this);
    this.toggleLanguageMenu = this.toggleLanguageMenu.bind(this);

    ReactGA.initialize('UA-75714602-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleExamSelection = async (examType, text_head, routeMap) => {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (!storage_session) return;

    const { token, idname } = storage_session;
    const { userRole } = this.state;

    const data = {
      token,
      idname,
      exam_selected: examType,
      organizationDomain: null,
      role: userRole,
    };

    const resp = await FD.callAPI(`${App_data.backend_api}/user/updateExamSelected`, data);
    if (resp.success) {
      await userStore.fetchProfile();
      localStorage.setItem('selectedmenu', examType);
      this.setState({ text_head });

      // Sidebar route handling
      for (const key in routeMap) {
        if (window.location.pathname.includes(key)) {
          localStorage.setItem('sidebarRoute', routeMap[key]);
          browserHistory.push({
            pathname: window.location.pathname,
            state: { token, idname, selectedMenu: examType },
          });
          break;
        }
      }
    }
  };

  // getUserDetails = async (token, idname) => {
  //   if (!token || !idname) return;
  //
  //   try {
  //     const resp = await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, {
  //       token,
  //       idname,
  //     });
  //
  //     if (!resp.success) {
  //       this.setState({ loggedIn: false, Expired: true });
  //       localStorage.clear();
  //       return;
  //     }
  //
  //     const {
  //       profileInfo: {
  //         username,
  //         selected_language,
  //         id,
  //         exam,
  //         exam_package,
  //         exam_selected,
  //         subscription_details,
  //         question_mode,
  //         role,
  //         imageUrl,
  //       },
  //     } = resp;
  //
  //     localStorage.setItem('questionMode', question_mode);
  //     localStorage.setItem('role', role);
  //
  //     userStore.setProfileInfo(resp.profileInfo);
  //
  //     this.setState({
  //       userRole: role,
  //       userName: username,
  //       language_selected: selected_language || 'EN',
  //       user_id: id,
  //       exam,
  //       exam_package,
  //       exam_selected,
  //       subscription_details,
  //       avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : this.state.avatar)),
  //       tokentimeout: false,
  //     });
  //   } catch (err) {
  //     console.error('Failed to fetch profile info', err);
  //   }
  // };

  //TODO: check exam URL & compare with current url if URL didnt math redirect to selected exam URL
  async componentDidMount() {
    const storageSession = JSON.parse(localStorage.getItem('localstorageval')) || {};
    // const { pathname } = this.props.location;
    // const { SOA_P, SOA_FM, FRM, CFA_LEVEL_1_2026, CFA_LEVEL_2_2026, CFA_LEVEL_3_2026, GMAT_FOCUS, EA, ESG } =
      // examNameAccordingToDB;
    // ----------- EXAM SELECTION -------------
    // const examRoutes = {
    //   [routeExamName.SOA_P]: SOA_P,
    //   [routeExamName.SOA_FM]: SOA_FM,
    //   [routeExamName.FRM]: FRM,
    //   [routeExamName.CFA_LEVEL_1_2024]: CFA_LEVEL_1_2026,
    //   [routeExamName.CFA_LEVEL_2]: CFA_LEVEL_2_2026,
    //   [routeExamName.CFA_LEVEL_3]: CFA_LEVEL_3_2026,
    //   [routeExamName.GMAT_FOCUS]: GMAT_FOCUS,
    //   [routeExamName.GMAT]: GMAT_FOCUS,
    //   [routeExamName.EA]: EA,
    //   [routeExamName.ESG]: ESG,
    // };

    // for (const route in examRoutes) {
    //   if (pathname.startsWith(route) || pathname.includes(route)) {
    //     this.handleExamSelection(
    //       examRoutes[route],
    //       examNames[examRoutes[route]],
    //       examObject[examRoutes[route]].sidebarRoutes,
    //     );
    //     break;
    //   }
    // }

    // ----------- LOGIN STATUS -------------
    const { idname = '', token = '' } = storageSession;
    this.setState({
      idname,
      token,
      loggedIn: !!(idname && token),
      pageName: window.location.href.split('/')[3].split('?')[0],
    });

    // await this.getUserDetails(token, idname);

    //Get profile info from storage observable
    this.dispose = autorun(() => {

      if(UserStore.profileInfo == null) return;

      const {
        username,
        selected_language,
        id,
        exam,
        exam_package,
        exam_selected,
        subscription_details,
        question_mode,
        role,
        imageUrl,
        organizationLogo
      } = UserStore.profileInfo;

      localStorage.setItem('questionMode', question_mode);
      localStorage.setItem('role', role);

      this.setState({
        userRole: role,
        userName: username,
        language_selected: selected_language || 'EN',
        user_id: id,
        exam,
        exam_package,
        exam_selected,
        subscription_details,
        avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : this.state.avatar)),
        tokentimeout: false,
        organizationLogo: organizationLogo,
      });
    })
    setTimeout(() => this.setState({ showCustomerly: true }), 6000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    if (this.dispose) this.dispose();
  }


  async getUserDetails() {
    const profileInfo = await userStore.getUserProfile();
    if (profileInfo == null) return;
    const {
      username,
      selected_language,
      id,
      exam,
      exam_package,
      exam_selected,
      subscription_details,
      question_mode,
      role,
      imageUrl,
    } = profileInfo;

    localStorage.setItem('questionMode', question_mode);
    localStorage.setItem('role', role);

    this.setState({
      userRole: role,
      userName: username,
      language_selected: selected_language || 'EN',
      user_id: id,
      exam,
      exam_package,
      exam_selected,
      subscription_details,
      avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : this.state.avatar)),
      tokentimeout: false,
    });
  }

  async componentDidUpdate(prevProps) {
    const { setIsChildChangedFalse, location, isChildChanged } = this.props;
    const { loggedIn, pageName, token, idname } = this.state;

    if (
      location.pathname.includes('profile/profileInfo') &&
      (isChildChanged || prevProps.location.pathname !== location.pathname)
    ) {
      await this.getUserDetails(token, idname);
      setIsChildChangedFalse();
    }

    // ✅ Auto logout if localStorage cleared but state still logged in
    const storageSession = JSON.parse(localStorage.getItem('localstorageval'));
    if (!storageSession && loggedIn) {
      if (pageName === 'forum') {
        this.setState({ loggedIn: false, tokentimeout: true });
      } else {
        this.logout();
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      ReactGA.initialize('UA-75714602-1');
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  convertToSlug(Text, post_id) {
    return Text.toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-')
      .concat('-', post_id);
  }

  customerly = () => {
    window.customerlySettings = {
      app_id: '54b14ea0',
      user_id: this.state.user_id,
      name: this.state.userName,
      email: this.state.idname,
      attributes: {
        exam: this.state.exam,
        exam_package: this.state.exam_package,
        exam_selected: this.state.exam_selected,
      },
    };
    !(function () {
      function e() {
        const e = t.createElement('script');
        (e.type = 'text/javascript'),
          (e.async = !0),
          (e.src = 'https://widget.customerly.io/widget/54b14ea0');
        const r = t.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(e, r);
      }
      var r = window,
        t = document,
        n = function () {
          n.c(arguments);
        };
      (r.customerly_queue = []),
        (n.c = function (e) {
          r.customerly_queue.push(e);
        }),
        (r.customerly = n),
        r.attachEvent ? r.attachEvent('onload', e) : r.addEventListener('load', e, !1);
      setTimeout(e, 1000);
    })();
  };

  logout = () => {
    const {
      userTokenAndEmail,
      selectedLanguage,
      selectedMenu,
      loginId,
      previousPath,
      previousParams,
      questionMode,
    } = localStorageKeys;
    const keysToRemove = [
      userTokenAndEmail,
      selectedLanguage,
      selectedMenu,
      loginId,
      previousPath,
      previousParams,
      questionMode,
    ];
    FD.callAPI(App_data.backend_api + '/user/logout', {
      token: this.state.token,
    }).then((resp) => {
      keysToRemove.forEach((key) => localStorage.removeItem(key));
      userStore.clear();
      disconnectSocket();
      browserHistory.push('/login');
    });
  };

  static contextTypes = {
    router: React.PropTypes.object,
  };

  goToLogin() {
    localStorage.setItem('urlToRedirect', this.props.location.pathname);
    browserHistory.push({
      pathname: '/',
      state: { pageToOpen: '1', urlToRedirect: this.props.location.pathname },
    });
  }

  goToRegister() {
    localStorage.setItem('urlToRedirect', this.props.location.pathname);
    browserHistory.push({
      pathname: '/',
      state: { pageToOpen: '2', urlToRedirect: this.props.location.pathname },
    });
  }
  toggleAccountMenu() {
    this.setState((prev) => ({ AccountdropdownOpen: !prev.AccountdropdownOpen }));
  }

  toggleLanguageMenu() {
    this.setState((prev) => ({ LanguagedropdownOpen: !prev.LanguagedropdownOpen }));
  }

  goToProfile() {
    browserHistory.push({
      pathname: '/profile',
      state: { token: this.state.token, idname: this.state.idname },
    });
  }

  getAvatarStyle(){
    return{
      backgroundImage: `url("${this.state.avatar}")`,
      backgroundSize: 'cover'
    }
  }

  render() {
    const { loggedIn, userRole, organizationLogo, userName, user_id, cart_count } = this.state;
    return (
    
        <header className='app-header navbar'>
          {/*<a className='navbar-brand header-logo-section' href='#' id='header-logo-section'>*/}
          {/*  <img*/}
          {/*    src={userRole === ROLES.PARTNER ? organizationLogo : ANALYSTPREP_LOGO}*/}
          {/*    className={userRole === ROLES.PARTNER ? 'circular-logo' : undefined}*/}
          {/*    alt=''*/}
          {/*  />*/}
          {/*</a>*/}
          <AppLogo userRole={userRole} organizationLogo={organizationLogo}/>
          <MobileSidebarToggle />

          {/* Desktop-only (≥575px) ✦ AI Tutor launcher — violet identity; CFA-L1-gated.
              Hidden on phones (the sidebar rail + per-page buttons cover mobile). */}
          {loggedIn && isAiTutorAvailable() && (
            <style dangerouslySetInnerHTML={{ __html: '@media (max-width:574.98px){.ap-ai-hdr-btn{display:none !important;}}' }} />
          )}
          {loggedIn && isAiTutorAvailable() && (
            <button
              type='button'
              className='ap-ai-hdr-btn ap-ai-launcher'
              aria-label='Open AI Tutor'
              onClick={() => window.dispatchEvent(new CustomEvent('aitutor:toggle'))}
              style={{
                display: 'inline-flex',
                maxHeight: 33,
                alignItems: 'center',
                alignSelf: 'center',
                gap: 7,
                marginLeft: 14,
                padding: '8px 15px',
                borderRadius: 10,
                border: 'none',
                cursor: 'pointer',
                color: '#fff',
                font: "700 14px 'Plus Jakarta Sans', system-ui, sans-serif",
                background: 'linear-gradient(135deg,#6d4bff,#4a2fe0)',
                boxShadow: '0 4px 14px rgba(74,47,224,.42)',
                whiteSpace: 'nowrap',
              }}
            >
              ✦ AI Tutor
            </button>
          )}

          <ul className='nav navbar-nav ml-auto header_right'>
            {loggedIn && <ExamDropdownMenu userRole={userRole} />}
            {loggedIn && (
              <HeaderCart
                pathname={this.props.location.pathname}
                isChildChanged={this.props.isChildChanged}
                setIsChildChangedFalse={this.props.setIsChildChangedFalse}
              />
            )}
            {loggedIn ? (
              <li className='nav-item nav-item-profile'>
                <Dropdown isOpen={this.state.AccountdropdownOpen} toggle={this.toggleAccountMenu}>
                  <a
                    role='button'
                    tabIndex={0}
                    onClick={this.toggleAccountMenu}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggleAccountMenu();
                      }
                    }}
                    aria-haspopup='true'
                    aria-expanded={this.state.AccountdropdownOpen}
                    aria-label={`Account menu for ${userName || 'user'}`}
                    className='nav-link dropdown-toggle nav-link profile-dropdown-toddle'
                  >
                    <span className='profile_name hidden-sm-down'>
                      {language.LC().WELCOME}, {userName}
                    </span>
                    <UserAvatar classNames={['top-header-imageprofile-circle']} />
                    <i className='fa fa-angle-down' aria-hidden='true' />
                  </a>
                  <DropdownMenu className='dropdown-menu'>
                    <DropdownItem
                      className='pointer_class'
                      disabled={!user_id}
                      onClick={() => _getProfile(this.convertToSlug(userName, user_id))}
                    >
                      {user_id ? (
                        <i className='fa fa-user' />
                      ) : (
                        <i className='fa fa-spinner fa-spin' />
                      )}
                      {language.LC().PROFILE}
                    </DropdownItem>
                    <DropdownItem className='pointer_class' onClick={this.logout}>
                      <i className='fa fa-lock' /> {language.LC().LOGOUT}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </li>
            ) : (
              <li className='cart_li_wrap pointer_class'>
                <p
                  role='button'
                  tabIndex={0}
                  onClick={this.goToLogin.bind(this)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.goToLogin();
                    }
                  }}
                >
                  Login
                </p>
                <p aria-hidden='true'> | </p>
                <p
                  role='button'
                  tabIndex={0}
                  onClick={this.goToRegister.bind(this)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.goToRegister();
                    }
                  }}
                >
                  Register
                </p>
                <div className='cart-section'>
                  <span
                    className='badge badge-pill badge-danger'
                    aria-hidden='true'
                  >
                    {cart_count}
                  </span>
                </div>
              </li>
            )}
          </ul>
        </header>
   
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js